module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hotsite-dgc', [_c('div', {
    staticClass: "conteudo"
  }, [_c('contato', [_c('p', [_c('strong', [_vm._v("FALE ‌‍⁣⁡‍⁡⁢⁡⁤‍⁢‍⁢⁢⁣‍⁢‌⁡‌⁢⁣⁡⁢⁡⁡‌⁤‍⁡⁢‍⁢‌⁤‌⁤⁤⁢⁣‍⁡⁡⁢‌⁢⁣‍⁢⁡⁢‍‌⁤‍‌⁡⁢⁢⁡⁡‍⁣⁢‍⁡‍⁣‌⁢⁡‍⁡⁢⁡⁢⁢‌⁡⁡⁢⁡⁢‍‌⁡⁣‍⁡⁡⁡‍⁡⁡⁡‌⁡‌⁢⁢⁡‍‌⁤‍⁢‍‌‍‌⁡‍⁣‍⁡‌⁡⁤‍⁡⁢‍‌⁢⁡‌‍⁡⁢⁢⁡⁤‍⁣⁣‍⁢⁢‌⁢⁣⁡‌⁢⁡‍⁢⁤‍⁡⁢‍‌⁢⁢⁢‍⁡⁡⁡⁡‍⁡⁢⁤⁢⁤‍⁡‌⁢⁡⁤⁡⁤‌⁡⁤⁢CONOSCO")])]), _c('ul', [_c('li', [_c('span', [_vm._v("Telefone institucional: (84) 3342-2328")]), _vm._v(" "), _c('span', [_vm._v("/ Ramais: 306, 307 e 303")])]), _c('li', [_c('span', [_vm._v("Telefone institucional (celular): (84) 99193-6296")])]), _c('li', [_c('span', [_vm._v("E-mail para contato:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "dgc@reitoria.ufrn.br"
    }
  }, [_vm._v("dgc@reitoria.ufrn.br")])])])]), _c('localizacao', [_c('p', [_vm._v("Texto com o endereço da unidade...")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e31ddf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/dgc/Contato.vue
// module id = 495
// module chunks = 0